import setElevation from './setElevation';
import { getElevation } from '../../lib/mapService';

/**
 * Set coordinate.
 * @param {!object} coordinate A coordinate.
 * @return {function} action dispatcher.
 */
export default (coordinate) => async (dispatch, getState) => {
  const elevation = await getElevation(coordinate);
  dispatch(setElevation(elevation));
};
